export const dataDevelopment1 = {
    // RecapTCHA
    REACT_APP_SITE_KEY: "6LcxYUgqAAAAAEEhd-8sZmujTs1kzMXHsdzCd4Bf",
    // Client Credentials
    REACT_APP_KEY_SECRET: "4003fac9543adb60a5522acb7c32761567dbcccaf4d07c7c1f6c43c11b6ca74e",
    // Area do cliente
    REACT_APP_API: "https://api-dev1.ituran.com.br/customer",
    // Trocas
    REACT_APP_API_CHANGE: "https://api-dev1.ituran.com.br/change/",
    // Sales
    REACT_APP_API_SALES: "https://api-dev1.ituran.com.br/sales/",
    // Sales Bo
    REACT_APP_API_SALES_BO: "https://api-dev1.ituran.com.br/salesbo/",
    // IturanSistemas
    REACT_APP_API_SYSTEMS: "https://sistemas.ituran.com.br/IturanSistemasIntegra/Ituran",
    // Livechat
    REACT_APP_LIVECHAT_BASE: "https://api-dev.ituran.com.br",
    REACT_APP_LIVECHAT_CHANNEL: "bot-sac",
    REACT_APP_LIVECHAT_LANG: "pt",
    REACT_APP_LIVECHAT_POLLING_MS: 5500,
    REACT_APP_PLATINUM_PRODUCTS: [7012, 7054, 7055],
    NEW_VERSION_QAR_ACTIVE: false
}
